import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({staticClass:"g-btn",style:(_vm.newStyles)},'v-btn',Object.assign({}, _vm.$attrs, {color: _vm.color, depressed: _vm.depressed, disabled: _vm.disabled, outlined: _vm.outlined, text: _vm.text}),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }